const isTest = process.env.NODE_ENV !== 'production';
const staticUrl = 'https://pages.anjukestatic.com/usersite';
// const staticUrlTest = 'https://userpages.anjuke.test/usersite';
// const getStaticUrl = url => (isTest ? staticUrlTest + url : staticUrl + url);
const getStaticUrl = url => (isTest ? staticUrl + url : staticUrl + url);

export { getStaticUrl };
